import React, { FC, useState } from 'react'
import { Button, notification } from 'antd'
import { DownloadOutlined, FileTextOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import DocumentService from '../services/DocumentService'

interface DocumentLinkProps {
  documentType: 'accessibility-action-plan' | 'accessibility-multiannual-scheme' | 'web-accessibility-declaration'
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  showIcon?: boolean
  actionType?: 'open' | 'download'
}

export const DocumentLink: FC<DocumentLinkProps> = ({
  documentType,
  children,
  className,
  style,
  showIcon = true,
  actionType = 'open'
}) => {
  const [loading, setLoading] = useState(false)
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language.includes('fr') ? 'fr' : 'en'

  const handleDocumentAction = async (e: React.MouseEvent) => {
    e.preventDefault()
    setLoading(true)

    try {
      if (actionType === 'download') {
        await DocumentService.downloadDocument(documentType, currentLanguage)
        notification.success({
          message: 'Téléchargement démarré',
          description: 'Le document va être téléchargé dans un instant.',
        })
      } else {
        // For opening documents, call the service synchronously to avoid popup blocking
        DocumentService.openDocumentInNewTab(documentType, currentLanguage)
      }
    } catch (error) {
      console.error('Document action error:', error)
      notification.error({
        message: 'Erreur',
        description: `Impossible d'${actionType === 'download' ? 'télécharger' : 'ouvrir'} le document. Veuillez réessayer plus tard.`,
      })
    } finally {
      setLoading(false)
    }
  }

  const icon = showIcon ? (
    actionType === 'download' ? <DownloadOutlined /> : <FileTextOutlined />
  ) : null

  return (
    <Button
      type="link"
      loading={loading}
      onClick={handleDocumentAction}
      className={className}
      style={{ padding: 0, height: 'auto', ...style }}
      icon={icon}
    >
      {children}
    </Button>
  )
}

export default DocumentLink
